import styled from "styled-components";
import { Strong } from "../../settings/layout";
import { Colors } from "../../settings/colors";

export const ListExpensesContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ListExpensesContainerHeader = styled.header`
    margin-bottom: 15px;
    padding: 15px 0;
    border-bottom: ${Colors.LightBorder} 1px solid;

    ${Strong} {
        font-size: 1.1rem;
    }
`;

export const ListExpensesWrapp = styled.div`
    display: flex;
    flex-direction: column;
`;
